import { ChevronRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { img } from '../data/siteData';

function Cards({ items, label = 'Explore' }) {
  return (
    <div className="cards">
      {items.map((item) => (
        <Link className="card" to={`/${item.slug}`} key={item.slug}>
          <img loading="lazy" decoding="async" src={img(item.image)} alt="" />
          <div>
            <small>{item.section || item.group || label}</small>
            <h3>{item.title}</h3>
            <p>{item.summary}</p>
            <span>{label} <ChevronRight size={16} /></span>
          </div>
        </Link>
      ))}
    </div>
  );
}

export default Cards;
